/* import __COLOCATED_TEMPLATE__ from './reaction-list-row.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();